/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Picture16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M13 2a2 2 0 011.995 1.85L15 4v8.132a2.01 2.01 0 01-1.843 1.862L13 14H3a2 2 0 01-1.995-1.85L1 12V4a2 2 0 011.85-1.995L3 2h10zm0 1H3a1 1 0 00-.993.883L2 4v5.459l2.67-2.335a.5.5 0 01.503-.093l.082.039.074.054 3.528 3.086 1.814-1.586a.5.5 0 01.502-.093l.082.039.074.054L14 10.96V4a1 1 0 00-.883-.993L13 3zm-2 2a1 1 0 110 2 1 1 0 010-2z"
        />
    </AccessibleSVG>
);

export default Picture16;
